import { Trans } from '@lingui/macro'
import { Box, Divider, Grid, Typography } from '@mui/material'
import { CurrencyFormated } from 'app/views/common/Formats'
import { grantStatusOptions } from './FormOtherGrants'

export const FormOtherGrantsPrint = ({ title, value = [] }) => {
  if (value.length === 0) {
    return (
      <>
        <div className='form-read-only-header'>{title}</div>
        <Typography className='form-read-only-text'>
          <Trans>This list is empty!</Trans>
        </Typography>
      </>

    )
  }

  return (
    <Box sx={{ width: '100%', padding: 0, backgroundColor: '#fff' }}>
      <Grid
        container
      >
        <Box className='form-print-new-title' sx={{ paddingX: '40px', paddingTop: '24px', paddingBottom: '8px' }}>
          {title}
        </Box>
        <Grid container sx={{ width: '100%', paddingX: '40px', paddingTop: '24px', paddingBottom: '16px' }}>
          <Grid item xs={5}>
            <Typography className='form-print-small-label'>
              <Trans>Grant name</Trans>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className='form-print-small-label'>
              <Trans>Grant amount</Trans>
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography className='form-print-small-label'>
              <Trans>Grants: State</Trans>
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ width: 'calc(100% + 32px)', marginLeft: '-16px', marginRight: '-16px', borderBottom: '2.5px solid #EEEFE6' }} />
      </Grid>
      {value.map((grant, index) => {
        const statusLabel = grantStatusOptions.find(
          item => item.value === grant.state
        )?.label
        return (
          <Box key={index}>
            <Divider sx={{ width: 'calc(100% + 32px)', marginLeft: '-16px', marginRight: '-16px' }} />
            <Grid
              container
              key={index}
              sx={{
                width: '100%',
                padding: '24px 40px 16px 40px',
                alignItems: 'center'
              }}
            >
              <Grid item xs={5} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography className='form-print-medium-label'>{grant.name?.trim()}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography className='form-print-medium-label'>
                  <CurrencyFormated value={grant.value} />
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography className='form-print-medium-label'>
                  {statusLabel}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )
      })}
    </Box>
  )
}
